module.exports = __webpack_public_path__ + "static/img/287_TO8_2443_og.04628a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/287_TO8_2443_og.jpg
// module id = dYpF
// module chunks = 0